import React from "react";
import { useState, useEffect, useCallback } from "react";
import { Box, Grid, Avatar, ButtonGroup, Typography, Button } from "@mui/material";
import { Add, Remove } from '@mui/icons-material';
import { CstmTextField } from "../../../../../../core/global/forms/CstmTextField";
import { isNumeric } from "../../../../../../core/global/Format";


export const Products = ({ products, setOrderList, orderList }) => {
    const processImageBlob = (product)=>{
        const url = URL.createObjectURL(product.file);
        return url;
        // return () => {
        //     URL.revokeObjectURL(url);
        // };
    }


    const handleChange = useCallback((e, type, val) => {
        e.preventDefault()
        setOrderList(prev => {
            const existing = prev.find(o => o.name === val.name)
            const currentValue = existing ? existing.value : val.value || 0
            let newValue = currentValue

            if (type === 'input') {
                const rawValue = e.target?.value
                newValue = isNumeric(rawValue) ? parseInt(rawValue) || 0 : 0
            } else if (type === 'add') {
                newValue = currentValue + 1
            } else if (type === 'remove') {
                newValue = Math.max(0, currentValue - 1)
            }

            if (newValue === 0) {
                return prev.filter(o => o.name !== val.name)
            }

            if (existing) {
                return prev.map(o => o.name === val.name ? { ...o, value: newValue } : o)
            } else {
                return [...prev, { ...val, value: newValue }]
            }
        })
        // eslint-disable-next-line
    }, [])
    
    return (
        <Box>
            <Grid container spacing={1} alignItems="start" justifyContent="flex-start">
                {
                    products.map((v, i)=>(
                        <MapList key={i} v={v} i={i} handleChange={handleChange} orderList={orderList} processImageBlob={processImageBlob}/>
                        )
                    )
                }
            </Grid>
        </Box>
    )
};

const MapList = React.memo(({ handleChange, v, i, orderList, handlePressEnd, handlePressStart, processImageBlob}) => {
    const orderItem = orderList.find(o => o.name === v.name)
    const qty = orderItem ? orderItem.value : v.value || 0

    const [imgUrl, setImgUrl] = useState(null);

    useEffect(() => {
        if (typeof v.image === "string") {
            setImgUrl(v.image); // Base64 works directly
        }
    }, [v.image]);



    return (
        <Grid item xs={6} md={3}>
            <Box  id={`walkthrough-order-step-${i}`} borderRadius="10px" display="flex" flexDirection="column" bgcolor="#FFFFFF" sx={{ outline: qty > 0 ? '2px solid green' : 'none' }} boxShadow="0px 2px 10px rgba(0, 0, 0, 0.1)" pb={0.5}>
                <Button onClick={(e) => handleChange(e, 'add', v)}>
                    <Box width="100%" height={120} display="flex" justifyContent="center" py={1}>
                        <Avatar variant="square" src={imgUrl} sx={{ width: 'auto', maxWidth: '100%', height: 'auto', borderRadius: '4px 4px 0 0', objectFit: 'cover', WebkitTouchCallout: 'none', WebkitUserSelect: 'none', userSelect: 'none' }} onContextMenu={(e) => e.preventDefault()} />
                    </Box>
                </Button>
                <Box width="100%" display="flex" flexDirection="column" justifyContent="flex-start" px={1}>
                    <Typography fontWeight={700} noWrap fontSize={14}>{v.name}</Typography>
                    <Box display="flex" justifyContent="space-between">
                        <Typography fontWeight={600} noWrap fontSize={12} color="primary.main">₱ {parseFloat(v.price).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Typography>
                        <Typography fontWeight={500} noWrap fontSize={12}>{parseInt(v.quantity)} {v.uom}{v.quantity > 1 && 's'}</Typography>
                    </Box>
                </Box>
                <Box width="100%" display="flex" alignItems="center" minHeight="30px">
                    <ButtonGroup size="small">
                        <Button onClick={(e) => handleChange(e, 'remove', v)} sx={{ border:'none', ':focus':{border:'none'}, ':hover':{border:'none'} }}><Remove/></Button>
                        <CstmTextField fullWidth size="small" variant="outlined" name="qty" inputProps={{ min: 0, maxLength: 5, style: { textAlign: 'center', color:'#333333', border:'none' }}} onChange={(e) => handleChange(e, 'input', v)} value={qty}/>
                        <Button onClick={(e) => handleChange(e, 'add', v)} sx={{ border:'none', ':focus':{border:'none'}, ':hover':{border:'none'} }}><Add/></Button>
                    </ButtonGroup>
                </Box>
            </Box>
        </Grid>
    )
})